import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { actionDataTableLoadItems } from 'client/helpers/dataTables';

import { USER_ROLE_ADMIN, USER_ROLE_FIELD_OPS } from 'common/userRoles';

import { SCREEN_ID_ADMIN_TENANT_SCREENING_CRITERIA } from 'client/constants/screenIds';

import { DATA_TABLE_SOURCE_PARTNER_TENANT_SCREENING_CRITERIA } from 'common/dataTableConstants';

import SrPage from 'client/components/SrPage';
import SrText from 'client/components/SrText';
import SrTenantScreeningCriteriaModal from 'client/components/SrTenantScreeningCriteriaModal';
import SrDataTablePartnerTenantScreeningCriteria from 'client/components/SrDataTablePartnerTenantScreeningCriteria';

import allowedRoles from 'client/helpers/allowedRoles';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';
import branch from 'client/core/branch';
import PartnerActions from 'client/actions/Partner';

@withTransitionHook
@allowedRoles({
  roles: [USER_ROLE_ADMIN, USER_ROLE_FIELD_OPS],
  redirectUrl: '/login',
  addRedirectQueryParam: true,
})
@withScreenId(SCREEN_ID_ADMIN_TENANT_SCREENING_CRITERIA)
@withScrollToTop
@branch({
  partnersList: ['partners', 'list'],
})
class AdminTenantScreeningCriteriaPage extends Component {
  static propTypes = {
    partnersList: PropTypes.array.isRequired,
  };

  static fetchData(match, inject) {
    return Promise.all([PartnerActions.getPartnerList(inject)]);
  }

  static getPageMetadata = () => ({
    pageTitle: 'Tenant Criteria Requirements | Sunroom Rentals',
  });

  constructor(props) {
    super(props);

    this.state = {
      isTenantScreeningCriteriaModalOpen: false,
    };
  }

  _tenantScreeningCriteriaModal = () => {
    this.setState({
      isTenantScreeningCriteriaModalOpen: !this.state.isTenantScreeningCriteriaModalOpen,
    });
  };

  _reloadDataTableTenantScreeningCriteriaPerPartner = (tenantScreeningCriteriaId) => {
    const { dispatch } = this.props;

    dispatch(actionDataTableLoadItems, {
      dataSource: DATA_TABLE_SOURCE_PARTNER_TENANT_SCREENING_CRITERIA,
      viewId: `by-tenant-screening-criteria-${tenantScreeningCriteriaId.id}`,
      filter: {
        'partnerTenantScreeningCriteria.tenantScreeningCriteriaId': tenantScreeningCriteriaId.id,
      },
      count: 1,
    });
  };

  render() {
    const { partnersList, dispatch } = this.props;

    const { isTenantScreeningCriteriaModalOpen } = this.state;

    return (
      <SrPage navbarProps={{ redirectLogoTo: '/admin' }}>
        <div className="width-90">
          <div>
            <SrText
              weight="bold"
              decoration="underline"
              cursor="pointer"
              onClick={this._tenantScreeningCriteriaModal}
            >
              New
            </SrText>
          </div>
          <SrDataTablePartnerTenantScreeningCriteria
            partnersList={partnersList}
            // eslint-disable-next-line max-len
            reloadDataTableTenantScreeningCriteriaPerPartner={
              this._reloadDataTableTenantScreeningCriteriaPerPartner
            }
          />
          {isTenantScreeningCriteriaModalOpen && (
            <SrTenantScreeningCriteriaModal
              partnersList={partnersList}
              onSubmit={this._reloadDataTableTenantScreeningCriteriaPerPartner}
              onClose={this._tenantScreeningCriteriaModal}
              dispatch={dispatch}
            />
          )}
        </div>
      </SrPage>
    );
  }
}

AdminTenantScreeningCriteriaPage.displayName = 'AdminTenantScreeningCriteriaPage';

export default AdminTenantScreeningCriteriaPage;
